import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { thrash } from '../../assets/svg/other'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { getGroupNutritionList, deleteFormOfEducation, getNutritionGroup, deleteGroupNutrition, getParallelsForGroupNutrition } from '../../actions/directoryCanteen'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { deleteLogSettingTable, getLogSetting, getLogSettingTables, getLogSettingTablesColumns } from '../../actions/settingLogging'


export default function SettingLogging() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { groupNutritionList, group } = useSelector(state => state.directoryCanteen)
  const { logSettingTables, logSettingList } = useSelector(state => state.log_setting)

  const [selectedItem, setSelectedItem] = useState(0)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    dispatch(getGroupNutritionList())
    dispatch(getParallelsForGroupNutrition())

    dispatch(getLogSettingTables())
    dispatch(getLogSetting())
  }, [])

  useEffect(() => {
    selectedItem && dispatch(getLogSettingTablesColumns(selectedItem.tablename))
  }, [selectedItem])

  useEffect(() => {
    group && setSelectedGroup(group)
  }, [group])

  const openModal = (data) => () => {
    setSelectedItem(data)
  }

  const closeModal = () => {

    setSelectedGroup(null)
    setSelectedItem(null)
  }

  const goHome = () => navigate('/')

  // const thrashClickHandler = (valid) => (e) => {
  //   e.stopPropagation()
  //   dispatch(deleteFormOfEducation(valid))
  // }

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteLogSettingTable(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { tablename, keyfieldname, active, description, fields, idlogset } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{tablename}</td>
        <td onClick={openModal(data)}>{keyfieldname}</td>
        <td onClick={openModal(data)}>{active}</td>
        <td onClick={openModal(data)}>{description}</td>
        <td onClick={openModal(data)}>{fields}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: idlogset, name: tablename })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          // confirmation={confirmation?.name} 
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {!!selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'730px'}
          width={'1000px'}
        />
      }
      <header className={styles.header}>
        <h1>Настройка журнализации</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table}>
        <thead>
          <tr>
            <th>Таблица</th>
            <th>Ключевое поле</th>
            <th>Вкл. журнал</th>
            <th>Атрибуты описывающие запись</th>
            <th>Журнализируемые атрибуты</th>
          </tr>
        </thead>
        <tbody>

          {logSettingList?.map(renderLi)}

        </tbody>
      </Table>
        <div className={styles.actions}>
          <Button style={{ padding: '.5rem 1.5rem' }} onClick={openModal('add')}>
            <IoIosAdd size={30} />
            Добавить
          </Button>
          <span className={styles.counter}>Всего записей: {logSettingList?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
